import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Button } from '../../Components/ui/button'
import env from '../../env/env'
import { get } from '../../http/restservice'
import FinancialPlannerQuestionnaire2 from '../FirstIdeas/FinancialPlannerQuestionnaire2'
import { ADMIN_BASE_PATH } from './firstUserIdeaUtils'

export default function AdminFirstIdeasQuestionnaire() {
  const { phoneNumber } = useParams()
  const [profile, setProfile] = useState(null)
  const [error, setError] = useState('')
  const [retry, setRetry] = useState(0)

  useEffect(() => {
    let active = true
    setProfile(null)
    setError('')
    async function load() {
      try {
        const details = await get(
          `${env.API_URL}customerservice/api/customer/details/${encodeURIComponent(phoneNumber)}`,
        )
        if (details?.status === 404) {
          if (active) setProfile({ phoneNumber })
          return
        }
        if (
          details?.isError ||
          String(details?.code) !== '200' ||
          (String(details?.customerFound) !== 'true' && String(details?.customerFound) !== 'false')
        )
          throw new Error('Unable to validate this customer. Please try again.')
        if (active)
          setProfile({
            ...(String(details.customerFound) === 'true' ? details.customerDetails : {}),
            phoneNumber,
          })
      } catch (failure) {
        if (active) setError(failure.message || 'Unable to load this customer.')
      }
    }
    load()
    return () => {
      active = false
    }
  }, [phoneNumber, retry])

  if (!profile)
    return (
      <div className='mx-auto max-w-xl space-y-4 p-8 text-center'>
        <p role={error ? 'alert' : 'status'}>{error || 'Validating customer…'}</p>
        {error && <Button onClick={() => setRetry((value) => value + 1)}>Retry</Button>}
        <Button asChild variant='outline'>
          <Link to={`${ADMIN_BASE_PATH}/firstUserIdeas/fill`}>Choose customer</Link>
        </Button>
      </div>
    )

  return (
    <>
      <div className='flex flex-wrap items-center justify-between gap-3 border-b p-4'>
        <p className='text-sm'>
          Filling for{' '}
          <strong>
            {[profile.firstName, profile.lastName].filter(Boolean).join(' ') || 'New customer'}
          </strong>
          {' · '}
          {phoneNumber}
        </p>
        <Button asChild variant='outline' size='sm'>
          <Link to={`${ADMIN_BASE_PATH}/firstUserIdeas`}>Back to First Ideas</Link>
        </Button>
      </div>
      <FinancialPlannerQuestionnaire2
        key={phoneNumber}
        customerProfile={profile}
        returnPath={`${ADMIN_BASE_PATH}/firstUserIdeas`}
      />
    </>
  )
}
